<template>
    <component
        :is="isInteractive ? 'button' : 'div'"
        :type="isInteractive ? 'button' : null"
        class="chat-reply-quote"
        :class="{
            'chat-reply-quote_interactive': isInteractive,
            'chat-reply-quote_unavailable': !preview.available,
            'chat-reply-quote_dark': dark,
        }"
        :aria-label="isInteractive ? 'Перейти к исходному сообщению' : null"
        @click="onClick"
    >
        <span class="chat-reply-quote__author" v-if="preview.available && preview.author">{{ preview.author }}</span>
        <span
            class="chat-reply-quote__text"
            :class="{ 'chat-reply-quote__text_muted': !preview.available || preview.isAttachment }"
            v-if="preview.text"
            >{{ preview.text }}</span
        >
    </component>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
class ChatReplyQuote extends Vue {
    // Результат replyPreview() из @/js/chatReply.
    @Prop({ type: Object, required: true })
    preview;

    // Цитата в сообщении ведёт к исходному; плашка над полем ввода — нет.
    @Prop({ type: Boolean, default: false })
    interactive;

    @Prop({ type: Boolean, default: false })
    dark;

    get isInteractive() {
        return this.interactive && this.preview.available;
    }

    onClick() {
        if (this.isInteractive) {
            this.$emit('click');
        }
    }
}

export default ChatReplyQuote;
</script>
<style lang="scss">
:root {
    --chat-reply-quote-accent: var(--color-green, #00a55a);
    --chat-reply-quote-background: rgba(0, 165, 90, 0.08);
    --chat-reply-quote-background-hover: rgba(0, 165, 90, 0.14);
    --chat-reply-quote-muted: #8a8a8a;
}

.chat-reply-quote {
    display: flex;
    flex-direction: column;
    min-width: 0;
    max-width: 100%;
    margin: 0;
    padding: 4px 8px;
    border: 0;
    border-left: 3px solid var(--chat-reply-quote-accent);
    border-radius: 4px;
    background: var(--chat-reply-quote-background);
    color: inherit;
    font: inherit;
    font-size: 0.875rem;
    line-height: 1.3;
    text-align: left;

    &_interactive {
        width: 100%;
        cursor: pointer;

        &:hover,
        &:focus-visible {
            background: var(--chat-reply-quote-background-hover);
        }
    }

    &_unavailable {
        border-left-color: var(--chat-reply-quote-muted);
        background: rgba(0, 0, 0, 0.04);
    }

    &_dark {
        background: rgba(255, 255, 255, 0.12);
    }

    &__author {
        overflow: hidden;
        font-weight: 600;
        color: var(--chat-reply-quote-accent);
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    &__text {
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-word;

        &_muted {
            font-style: italic;
            color: var(--chat-reply-quote-muted);
        }
    }
}
</style>
